import { render, staticRenderFns } from "./BuyBoxBanner.vue?vue&type=template&id=2a1b37ee&scoped=true"
import script from "./BuyBoxBanner.vue?vue&type=script&lang=ts&setup=true"
export * from "./BuyBoxBanner.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./BuyBoxBanner.vue?vue&type=style&index=0&id=2a1b37ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1b37ee",
  null
  
)

export default component.exports